import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { AdminShell } from '#layouts/AdminShell'
import { authClient } from '#lib/auth'
import { createTrpcClient } from '#lib/trpc'

export const Route = createFileRoute('/_admin')({
  beforeLoad: async () => {
    const { data } = await authClient.getSession()
    if (!data?.user) throw redirect({ to: '/login' })
    const me = await createTrpcClient().profile.me.query()
    if (me.role !== 'admin') throw redirect({ to: '/' })
  },
  component: () => (
    <AdminShell>
      <Outlet />
    </AdminShell>
  ),
})
